export const usageConstants = {
  USAGE_METER_DETAIL: "USAGE_METER_DETAIL",
  USAGE_USER_DATA: "USAGE_USER_DATA",
};
